import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { inToolboxItems } from '../../canvas/tooling/ToolboxController';
import { inTools } from '../../canvas/tooling/ToolManager';
import { Package, PackageHost } from '../../Container';
import { inExportAdapter } from '../dataExport/ExportAdapter';
import { inLensAspectProvider } from '../lens/LensReflector';
import { createIndexCard } from './IndexCardCommands';
import { IndexCardExports } from './IndexCardExports';
import { indexCardTool } from './IndexCardTool';
import { paperToolboxItem } from './PaperToolboxItem';
import { createRoadmapCard } from './RoadmapCardCommands';
import { RoadmapCardExports } from './RoadmapCardExports';
import { RoadmapCardLensAspectProvider } from './RoadmapCardLensReflector';
import { RoadmapCardMechanics } from './RoadmapCardMechanics';
import { roadmapCardTool } from './RoadmapCardTool';
import { createSticky, } from './StickyCommands';
import { StickyExportAdapter } from './StickyExports';
import { StickyMechanics } from './StickyMechanics';
import { stickyTool } from './StickyTool';
import { createTaskCard } from './TaskCardCommands';
import { TaskCardExports } from './TaskCardExports';
import { taskCardTool } from './TaskCardTool';

export class PaperPackage implements Package {

    public install = (host: PackageHost) => host
        .register(RoadmapCardMechanics, 'singleton', 'startable')
        .register(StickyMechanics, 'singleton', 'startable')
        .plug(inCommands(createIndexCard, createSticky, createTaskCard, createRoadmapCard))
        .plug(inTools(indexCardTool, stickyTool, taskCardTool, roadmapCardTool))
        .plug(inToolboxItems(paperToolboxItem))
        .plug(inLensAspectProvider(RoadmapCardLensAspectProvider))
        .plug(inExportAdapter(IndexCardExports))
        .plug(inExportAdapter(StickyExportAdapter))
        .plug(inExportAdapter(TaskCardExports))
        .plug(inExportAdapter(RoadmapCardExports))
        // .plug(inHaugs(PaperHaug))
        ;
}
